const REPO = 'https://raw.githubusercontent.com/pharo-project/pharo-gsoc/'

const BRANCH = 'master'

export const BASE = REPO + '/' + BRANCH + '/data'

export const IDEAS_FILE = BASE + '/ideas.json';
export const SUPERVISORS_FILE = BASE + '/supervisors.json';
export const IMAGE_FOLDER =  BASE + '/img';
